import React from 'react';
import { Table } from 'semantic-ui-react';

const BlankBodyLine = () => <Table.Cell colSpan={8} />;

export default BlankBodyLine;
